import React, { Fragment } from 'react'

const FilterDesignManagementTabs = ({name}) => {
    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12 dashBoard">
                        <h2>{name}</h2>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default FilterDesignManagementTabs
